
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/bole_stock",
      function () {
        return require("private-next-pages/bole_stock/index.page.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/bole_stock"])
      });
    }
  